import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ThemeStyle, { FontSize } from '../../../lib/style/ThemeStyle';

const Icon = ({ iconName, size = 24, ...props }) => {
  return (
    <IconStyle className="material-icons" size={size} {...props}>
      {iconName}
    </IconStyle>
  );
};

export default Icon;

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
};

const IconStyle = styled.i`
  cursor: ${(props) => (props.onClick ? 'pointer' : 'unset')};
  ${FontSize}
`;

export const CheckIcon = ({
  checked,
  defaultBackgroundColor = 'white',
  ...props
}) => (
  <Icon
    size={16}
    iconName="check"
    style={{
      border: `solid 1px ${
        ThemeStyle.color[checked ? 'orangePink' : 'pinkishGrey']
      }`,
      borderRadius: '3px',
      background:
        ThemeStyle.color[checked ? 'orangePink' : defaultBackgroundColor],
      color: 'white',
    }}
    {...props}
  />
);
